export default {
  all: "*",
  impersonation: "Impersonation",
  facultyHead: "Workloads.FacultyHead",
  employee: "Workloads.Employee",
  degreeCoordinator: "Workloads.DegreeCoordinator",
  viewOnly: "Workloads.ViewOnly",
  expertsEditor: "Experts.Editor",
  expertsAdmin: "Experts.Admin",
  expertsViewer: "Experts.Viewer",
  translationalTeam: "Placements.TranslationalTeam",

  // Change Aug 10, 2022, Marina:

  // remove these
  // buyoutManager: "Workloads.BuyoutManager",
  // buyoutViewer: "Workloads.BuyoutViewer",

  // replace w/ these
  buyoutManager: "Buyouts.Manager",
  buyoutViewer: "Buyouts.Viewer",

  // Oct. 20, 2021: Marina and Andrew:
  // SummerPay.Manager - needed to change status
  // SummerPay.Viewer - needed to view all requests
  // SummerPay.Submitter - needed to submit requests and edit requests, and allows viewing requests created by the user or where user is assigned as the faculty
  // db: hs_students, table: dbo.Roles
  spManager: "SummerPay.Manager",
  spViewer: "SummerPay.Viewer",
  spSubmitter: "SummerPay.Submitter",

  workloadsManager: "Workloads.Manager",
  workloadsSubmitter: "Workloads.Submitter",
  workloadsViewer: "Workloads.Viewer",

  employeesViewer: "Experts.Employees.Viewer",
  overloadsManager: "Overloads.Manager",

  adminSupervisor: "Workloads.Administrative.Supervisor",
  adminViewer: "Workloads.Administrative.Viewer",

  affiliateRequestsManager: "Workloads.AffiliateRequests.Manager",
  affiliateRequestsViewer: "Workloads.AffiliateRequests.Viewer",

  courseEquivalentsManager: "CourseEquivalents.Manager",
  courseEquivalentsViewer: "CourseEquivalents.Viewer",
  courseEquivalentsFaculty: "CourseEquivalents.Faculty",
}
